
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import Filter from 'components/Filter'
import partial from 'utils/partial'
import Loader from 'components/Loader'

export default class PivotTable extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    total: PropTypes.object,
    dimensions: PropTypes.array,
    availableDimensions: PropTypes.object,
    metrics: PropTypes.array,
    filters: PropTypes.object,
    dimensionCell: PropTypes.func,
    metricCell: PropTypes.func,
    onFilterChange: PropTypes.func
  }

  render() {
    return (
      <div className='pivot-table'>
        <table>
          {this.renderHeader()}
          {this.renderBody()}
          {this.renderFooter()}
        </table>
      </div>
    )
  }

  renderBody() {
    const {data, dimensions, metrics, dimensionCell, metricCell} = this.props
    if (!data || !metrics) {
      return (
        <tbody>
          <tr>
            <td className='padding-loading' colSpan={dimensions.length + metrics.length}>
              <Loader />
            </td>
          </tr>
        </tbody>
      )
    }

    if (!dimensions || !dimensions.length) {
      return (
        <tbody>
          <tr>
            <td colSpan={dimensions.length + metrics.length}>
              Add one or more dimensions to display data.
            </td>
          </tr>
        </tbody>
      )
    }

    if (data && data.length === 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={dimensions.length + metrics.length}>
              We don{"'"}t have any data for the selected period. Try another?
            </td>
          </tr>
        </tbody>
      )
    }

    const rowSpans = {}

    return (
      <tbody>
        {data.concat().reverse().map((row, rowIndex, rows) => {
          return (
            <tr key={rowIndex}>
              {dimensions.map((dimension, cellIndex) => {
                const value = get(row, dimension.key)
                const nextValue = get(rows[rowIndex + 1], dimension.key)
                const lastSpan = rowSpans[dimension.key]
                const prevDimensions = dimensions.slice(0, cellIndex).every(dimension =>
                  get(row, dimension.key) === get(rows[rowIndex + 1], dimension.key)
                )
                if (value === nextValue && (cellIndex === 0 || prevDimensions)) {
                  if (!rowSpans[dimension.key]) {
                    rowSpans[dimension.key] = 2
                  } else {
                    rowSpans[dimension.key] += 1
                  }
                } else {
                  rowSpans[dimension.key] = 0
                }
                if (rowSpans[dimension.key] === 0) {
                  return (
                    <td rowSpan={lastSpan || null} key={`${rowIndex}_${dimension.key}`}>
                      {dimensionCell(value, dimension)}
                    </td>
                  )
                } else {
                  return null
                }
              })}
              {metrics.map(metric => {
                const value = get(row, metric.key)
                return <td key={`${rowIndex}_${metric.key}`}>{metricCell(value, metric, row.dimensions)}</td>
              })}
            </tr>
          )
        }).reverse()}
      </tbody>
    )
  }

  renderHeader() {
    const {dimensions, metrics, filters, availableDimensions, onFilterChange} = this.props
    const hasExtraHeader = metrics.some(metric => metric.variantGroup)
    let colSpan = 0

    const firstRow = metrics.map((metric, index) => {
      const hasVariants = !!metric.variantGroup
      const value = metric.variantGroup
      const nextValue = (metrics[index + 1] || {}).variantGroup
      const lastColSpan = colSpan
      if (nextValue && value === nextValue) {
        colSpan = (colSpan || 1) + 1
        return null
      } else {
        colSpan = 0
      }

      return (
        <th
          className='pivot-table_metric'
          key={index}
          rowSpan={hasVariants ? null : 2}
          colSpan={lastColSpan}
        >
          {hasVariants ? metric.metricLabel : metric.label}
        </th>
      )
    })

    const secondRow = metrics
      .concat()
      .reverse()
      .map((metric, index, metrics) => {
        if (metric.variantGroup) {
          return (
            <th className='pivot-table_metric' key={index}>
              {metric.variantLabel}
            </th>
          )
        }
      })
      .reverse()

    return (
      <thead>
        <tr>
          {dimensions.map((dimension, index) =>
            <th className='pivot-table_dimension' rowSpan={hasExtraHeader ? 2 : null} key={index}>
              {dimension.label}
              {availableDimensions && availableDimensions[dimension.id] && availableDimensions[dimension.id].length > 1
                ? <Filter
                  options={availableDimensions[dimension.id]}
                  values={(filters && filters[dimension.id]) || []}
                  addIcon='filter'
                  className='pivot-table_filter'
                  onChange={partial(onFilterChange, dimension.id)}
                />
                : null}
            </th>
          )}
          {firstRow}
        </tr>
        {hasExtraHeader && <tr className='pivot-table_variant'>{secondRow}</tr>}
      </thead>
    )
  }

  renderFooter() {
    const {dimensions, metrics, total, metricCell} = this.props
    if (!total) return null

    return (
      <tfoot>
        <tr>
          <td colSpan={dimensions.length} className='pivot-table_dimension'>Total</td>
          {metrics.map((metric, index) => {
            return <td key={index} className='pivot-table_metric'>{metricCell(total[metric.key], metric, {})}</td>
          })}
        </tr>
      </tfoot>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/PivotTable/index.js